import BotDialogType from '../../core/type/dialog/BotDialogType';
import TextInputType from '../../core/type/input/TextInputType';
import UserDialogType from '../../core/type/dialog/UserDialogType';
import Case from '../../core/type/operation/Case';
import Switch from '../../core/type/operation/Switch';
import { sendBotResponse } from './util';
import RaterInputType from '../../core/type/input/RaterInputType';
import Interceptor from '../../core/type/operation/Interceptor';
import SelectorInputType from '../../core/type/input/SelectorInputType';
import ButtonInputType from '../../core/type/input/ButtonInputType';
// import ButtonInputType from '../../components/layout/ButtonInputType';

export default [
  new BotDialogType({
    message: 'E que tipo de produto(s) você quer ajuda de um parceiro para vender online?',
    checkpoint: true,
  }),

  new SelectorInputType({
    key: 'sales_product',
    type: 'checkbox',
    column: 'half',
    options: 'sales_product_options',
  }),

  new Interceptor(async (data) => new Promise((resolve) => {
    const values = [...data.sales_product];
    if (values.find((v) => v.key === 'NONE')) {
      resolve({
        ...data,
        information: { ...data.information, sales_product: data.sales_product },
        sales_product: 'Nenhuma das opções indicadas.',
      });
    } else {
      resolve({
        ...data,
        information: { ...data.information, sales_product: data.sales_product },
        sales_product: `${data.sales_product?.map((obj) => obj.label).join(', ')}`,
      });
    }
  })),

  new UserDialogType({
    message: '#{sales_product}',
  }),

  new BotDialogType({
    message: 'Entendi. E qual o seu nível de experiência com marketing e vendas?',
    checkpoint: true,
  }),

  new ButtonInputType({
    key: 'expertize_level',
    buttons: [
      { value: 'STARTING', text: 'Estou começando agora, preciso de ajuda' },
      { value: 'EXPERIENCED', text: 'Já tenho experiência, busco melhorar meus resultados' },
    ],
  }),

  new Interceptor(async (data) => new Promise((resolve) => {
    resolve({
      ...data,
      information: { ...data.information, expertize_level: data.expertize_level },
      expertize_level: data.expertize_level.text,
    });
  })),

  new BotDialogType({
    message: '',
    checkpoint: true,
  }),

  new Switch({
    ref: 'information.expertize_level',
    cases: [
      new Case({
        express: '\'$v\' === \'STARTING\'',
        components: [
          new BotDialogType({
            message: 'Entendi! E qual o momento do seu negócio hoje?',
            checkpoint: true,
          }),

          new SelectorInputType({
            key: 'company_moment',
            type: 'radio',
            column: 'full',
            options: 'option_company_moment',
          }),

          new Interceptor(async (data) => new Promise((resolve) => {
            resolve({
              ...data,
              information: { ...data.information, company_moment: data.company_moment },
              company_moment: data.company_moment.text,
            });
          })),

          new UserDialogType({
            message: '#{company_moment}',
          }),

          new Switch({
            ref: 'information.company_moment',
            cases: [
              new Case({
                express: '\'$v\' === \'IDEA\' || \'$v\' === \'OPENING\'',
                components: [
                  new BotDialogType({
                    message: 'Entendido! Talvez essa seja a oportunidade para encontrar um parceiro que possa ajudar você a dar os próximos passos.',
                    checkpoint: true,
                  }),

                ],
              }),
            ],
          }),

        ],
      }),
    ],
  }),

  new Switch({
    ref: 'information.company_moment',
    cases: [
      new Case({
        express: '\'$v\' === \'undefined\' || \'$v\' === \'ALREADY_SELLING\'',
        components: [
          new BotDialogType({
            message: 'Legal! Talvez essa seja a oportunidade para encontrar um parceiro que possa ajudar você a melhorar os seus resultados.',
            checkpoint: true,
          }),

          new BotDialogType({
            message: 'Qual o faturamento médio mensal da sua empresa? Leve em consideração os últimos 6 meses.',
            checkpoint: true,
          }),

          new BotDialogType({
            message: 'Não se preocupe, utilizamos essa informação apenas para poder sugerir as soluções ideais para o perfil do seu negócio.',
          }),

          new TextInputType({
            placeholder: '',
            key: 'monthly_income',
            mask: 'currency',
          }),

          new Interceptor(async (data) => new Promise((resolve) => {
            resolve({
              ...data,
              information: { ...data.information, monthly_income: data.monthly_income },
              monthly_income: data.monthly_income.maskedValue,
            });
          })),

          new UserDialogType({
            message: '#{monthly_income}',
          }),

        ],
      }),
    ],
  }),
  sendBotResponse(),
];
